import { isAxiosError } from 'axios';

const FALLBACK_MESSAGE =
  'Sorry, your request could not be processed. An error occurred, try again.';

const asMessage = (value: unknown) =>
  typeof value === 'string' && value.trim() ? value : undefined;

/**
 * The message the API put in its error body, e.g. "Incorrect PIN". Undefined
 * when the request got no response or the body carries no message.
 */
export const getApiResponseMessage = (error: unknown): string | undefined => {
  if (!isAxiosError(error)) {
    return undefined;
  }

  const data = error.response?.data as any;

  return (
    asMessage(data?.message) ||
    asMessage(data?.error?.message) ||
    asMessage(data?.metadata?.message) ||
    asMessage(data?.error)
  );
};

/**
 * A message fit to show the customer. Axios' own text ("Request failed with
 * status code 400", "Network Error") is never shown; the fallback is used
 * when the API gave no reason.
 */
export const getErrorMessage = (
  error: unknown,
  fallback = FALLBACK_MESSAGE,
): string => {
  if (isAxiosError(error)) {
    return getApiResponseMessage(error) || fallback;
  }

  return (error instanceof Error && asMessage(error.message)) || fallback;
};

export const extractApiErrorMessage = (error: unknown): string =>
  getErrorMessage(error);
